<div
  *transloco="let transloco"
  [ngClass]="{
    'flex-col': !(this.props.iconPre || this.props.iconPost)
  }"
  class="flex">
  <p-inputgroup>
    @if (this.props.iconPre) {
      <p-inputgroup-addon>
        <i [class]="this.props.iconPre"></i>
      </p-inputgroup-addon>
    }
    <p-inputmask
      [characterPattern]="this.props.characterPattern || '[A-Za-z]'"
      [formControl]="this.formControl"
      [formlyAttributes]="this.field"
      [mask]="this.props.mask"
      [ngClass]="{
        'ng-dirty ng-invalid p-invalid': this.showError
      }"
      [placeholder]="transloco(this.props.placeholder || '')"
      [readonly]="this.props.readonly"
      [slotChar]="this.props.slotChar || '_'"
      class="inline-flex w-full">
    </p-inputmask>
    @if (this.props.iconPost) {
      <p-inputgroup-addon>
        <i [class]="this.props.iconPost"></i>
      </p-inputgroup-addon>
    }
  </p-inputgroup>
</div>
